import React from 'react';
import { get, startCase } from 'lodash';
import formatDate from 'common/utils/Dates/formatDate';
import TimelineEventDetails from './TimelineEventDetails';

export const isValidUUID = (value) => (
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(value)
);

export const isValidDate = (value) => (
  /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?Z?$/.test(value)
);

export const getTimelineEventDetails = (eventItems, eventDate) => (
  eventItems.length > 0 ? <TimelineEventDetails eventItems={eventItems} eventDate={eventDate} /> : null
);

export const getTimelineAssignmentMessage = (timelineEvent) => {
  const additionalData = get(timelineEvent, 'additional_data', {});
  const assigneeChange = get(timelineEvent, 'changes', []).find((change) => change.field_name === 'assignee_id');
  const assignedTo = additionalData.assigned_to;
  const employeeName = additionalData.employee_name || 'System';

  if (!assigneeChange) {
    return `Updated by ${employeeName}`;
  }

  if (assigneeChange.to === null) {
    return `Unassigned by ${employeeName}`;
  }

  if (assigneeChange.from === null) {
    return assignedTo ? `Assigned to ${assignedTo} by ${employeeName}` : `Assigned by ${employeeName}`;
  }

  return assignedTo ? `Reassigned to ${assignedTo} by ${employeeName}` : `Reassigned by ${employeeName}`;
};

export const formatTimelineChangeItems = ({
  eventChanges,
  additionalData = {},
  excludedFieldNames = [],
  additionalDataFields = [],
  noteFieldNames = [],
  labelOverrides = {},
}) => {
  const assigneeChange = eventChanges.find((change) => change.field_name === 'assignee_id');

  const formattedChanges = eventChanges
    .filter((change) => !['assignee_id', ...excludedFieldNames].includes(change.field_name))
    .map((change) => {
      const changedTo = change.to;

      if (isValidUUID(changedTo)) return null;

      if (isValidDate(changedTo)) {
        return {
          label: labelOverrides[change.field_name] || startCase(change.field_name),
          value: formatDate(changedTo),
        };
      }

      if (typeof changedTo === 'boolean') {
        return {
          label: labelOverrides[change.field_name] ||
            (noteFieldNames.includes(change.field_name) ? 'Notes' : startCase(change.field_name)),
          value: changedTo ? 'Yes' : 'No',
        };
      }

      return {
        label: labelOverrides[change.field_name] ||
          (noteFieldNames.includes(change.field_name) ? 'Notes' : startCase(change.field_name)),
        value: changedTo === null ? 'Not Specified' : changedTo.toString(),
      };
    })
    .filter(Boolean);

  const assigneeItems = (() => {
    if (!assigneeChange) return [];
    if (assigneeChange.to === null) return [{ label: 'Assigned To', value: 'Unassigned' }];
    if (additionalData.assigned_to) return [{ label: 'Assigned To', value: additionalData.assigned_to }];
    return [];
  })();

  const formattedAdditionalData = additionalDataFields
    .filter((fieldName) => additionalData[fieldName])
    .map((fieldName) => ({
      label: labelOverrides[fieldName] || startCase(fieldName),
      value: additionalData[fieldName],
    }));

  return [...formattedChanges, ...assigneeItems, ...formattedAdditionalData];
};
